// German for SourcesPage (BUILD-BRIEF-R6 §5.1, §5.5). §5.5's own table is used verbatim for the
// rows it names; everything else this page adds is translated in the same register.
import { registerDe } from '../i18n/index.js';

registerDe({
  // §5.5, verbatim
  'Sources': 'Quellen',
  'What the record reads': 'Was die Akte liest',
  'Refresh all': 'Alle aktualisieren',
  'Refresh now': 'Jetzt aktualisieren',
  'Documents': 'Dokumente',
  'Changed at last check': 'Geändert beim letzten Abruf',
  'disabled': 'deaktiviert',
  'parser not built yet': 'Parser noch nicht gebaut',
  'no_parser': 'Parser noch nicht gebaut',
  'Entries': 'Einträge',
  'Series points': 'Reihenpunkte',
  'Refreshes': 'Aktualisierungen',
  'Waiting': 'Wartend',
  'Propose': 'Vorschlagen',
  'kept · no series named': 'abgelegt · keine Reihe benannt',
  'unchanged': 'unverändert',
  'changed': 'geändert',
  'refused': 'verweigert',
  'daily · {signal}': 'täglich · {signal}',
  'Every vintage kept; the newest is what the parsers read': 'Jede Fassung bleibt; die Parser lesen die neueste',

  // this page's own additions
  'sources': 'Quellen',
  'documents kept': 'Dokumente abgelegt',
  'last refresh': 'letzte Aktualisierung',
  'of {n}': 'von {n}',
  '{n} superseded': '{n} ersetzt',
  'by the latest refresh of each': 'nach der jeweils letzten Aktualisierung',
  '{resolved} on the record · {open} waiting': '{resolved} in der Akte · {open} wartend',
  '{n} series': '{n} Reihen',
  'counting…': 'wird gezählt…',
  'Source': 'Quelle',
  'kind': 'Art',
  'cadence': 'Rhythmus',
  'detection': 'Erkennung',
  'status': 'Status',
  'last checked': 'zuletzt geprüft',
  'last changed': 'zuletzt geändert',
  'filed': 'abgelegt',
  'next check': 'nächste Prüfung',
  'per document': 'pro Dokument',
  'Disable this source': 'Diese Quelle deaktivieren',
  'Enable this source': 'Diese Quelle aktivieren',
  'Open in Review': 'In der Prüfung öffnen',
  'No source registered yet.': 'Noch keine Quelle registriert.',
  'Could not load the sources: {error}': 'Die Quellen konnten nicht geladen werden: {error}',
  'Loading…': 'Wird geladen…',
  'source': 'Quelle',
  'filename': 'Dateiname',
  'version': 'Version',
  'Last-Modified': 'Last-Modified',
  'sha256': 'sha256',
  'fetched': 'abgerufen',
  'parsed': 'ausgewertet',
  'No document fetched yet.': 'Noch kein Dokument abgerufen.',
  'Could not load the documents: {error}': 'Die Dokumente konnten nicht geladen werden: {error}',
  'superseded': 'ersetzt',
  'show the previous vintage': 'die vorherige Fassung anzeigen',
  'show': 'anzeigen',
  'hide': 'ausblenden',
  'when': 'wann',
  'outcome': 'Ergebnis',
  'documents new': 'Dokumente neu',
  'entries added/gone': 'Einträge neu/entfallen',
  'points new/superseded': 'Punkte neu/ersetzt',
  'claims filed/held/waiting': 'Behauptungen abgelegt/übernommen/wartend',
  'report': 'Bericht',
  'running': 'läuft',
  'No refresh has run yet.': 'Noch keine Aktualisierung gelaufen.',
  'Could not load the refreshes: {error}': 'Die Aktualisierungen konnten nicht geladen werden: {error}',
  'entries resolved': 'Einträge aufgelöst',
  'entries proposed': 'Einträge vorgeschlagen',
  'claims held on arrival': 'Behauptungen sofort übernommen',
  'claims waiting in Review': 'Behauptungen wartend in der Prüfung',
  'anomalies': 'Anomalien',
  'This refresh has not finished yet.': 'Diese Aktualisierung ist noch nicht abgeschlossen.',
  'name': 'Name',
  'category': 'Kategorie',
  'locality': 'Ort',
  'state': 'Zustand',
  'unresolved': 'ungelöst',
  'ambiguous': 'mehrdeutig',
  'proposed': 'vorgeschlagen',
  'failed': 'fehlgeschlagen',
  'Nothing waiting — every named entry is either resolved or on the record.':
    'Nichts wartend — jeder genannte Eintrag ist entweder aufgelöst oder in der Akte.',
  'Could not load the waiting entries: {error}': 'Die wartenden Einträge konnten nicht geladen werden: {error}',
  'not collected': 'nicht erfasst',
  'settings': 'Einstellungen',
  'last report': 'letzter Bericht',
  'Refresh all requested.': 'Alle Aktualisierungen angefordert.',
  '{key}: {outcome}': '{key}: {outcome}',
  'Filed {ref}.': '{ref} abgelegt.',
  'gone since last vintage': 'seit der letzten Fassung verschwunden',
  'The organisation, its facts and its links are untouched — a refresh retracts nothing.': 'Die Organisation, ihre Fakten und ihre Verbindungen bleiben unberührt — eine Aktualisierung zieht nichts zurück.',
  'Could not load the entries that left: {error}': 'Die verschwundenen Einträge konnten nicht geladen werden: {error}',
  'Every name a source printed before, it prints still.': 'Jeden Namen, den eine Quelle zuvor druckte, druckt sie weiterhin.',
  'gone': 'verschwunden',
  'held': 'übernommen',
  'matched': 'zugeordnet',
}, 'SourcesPage');
